import { render, staticRenderFns } from "./TaskSelectionComponent2.vue?vue&type=template&id=4aaa101a&"
import script from "./TaskSelectionComponent2.vue?vue&type=script&lang=js&"
export * from "./TaskSelectionComponent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aaa101a')) {
      api.createRecord('4aaa101a', component.options)
    } else {
      api.reload('4aaa101a', component.options)
    }
    module.hot.accept("./TaskSelectionComponent2.vue?vue&type=template&id=4aaa101a&", function () {
      api.rerender('4aaa101a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/TaskSelectionComponent2.vue"
export default component.exports